<template>
  <div id="compact-email-list" ref="list" class="width-stretch height-stretch overflow-hidden">
    <div :style="{display: maxHeight !== undefined ? 'flex' : 'none', flexDirection: 'column'}">
      <div
        class="list-scroll flex-col"
        style="overflow-y: auto"
        :style="{height: maxHeight - 40}"
      >
        <div class="flex-stretch flex-col gap-sm pb-xs">
          <CompactInboxItem
            v-for="(email, idx) in emails"
            :key="email.id"
            :id="`compact-email-list-item-${idx}`"
            :email="email"
            :ctrlKey="ctrlKey"
            @select-item="handleSelectItem"
          />
        </div>
      </div>

      <div class="flex-col justify-content-end" style="height: 39px; overflow: hidden; margin-left: -8px">
          <dd-pagination
            class="m-0"
            compact
            :show-per-page="false"
            :paginator="pagination"
            @go-to-page="handlePaginationChange"
          />
      </div>

    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import CompactInboxItem from "./CompactInboxListItemComponent.vue";


export default {
  name: "CompactInboxListComponent.vue",
  components: { CompactInboxItem },
  data() {
    return {
      maxHeight: undefined,
      ctrlKey: false
    }
  },
  mounted() {
    this.setMaxHeight();
    window.addEventListener('resize', this.setMaxHeight);
    window.addEventListener('keydown', this.setControl);
    window.addEventListener('keyup', this.setControl);
    this.scrollToItem();
  },
  unmount(){
    window.removeEventListener('resize', this.setMaxHeight);
    window.removeEventListener('keydown', this.setControl);
    window.removeEventListener('keyup', this.setControl);
  },
  methods: {
    ...mapActions('email', [
        "setPagination",
        "setSelectedEmails"
    ]),
    setMaxHeight(){
      this.maxHeight = undefined;
      setTimeout(()=>{
        if ( !this.$refs.list ) return;
        this.maxHeight = this.$refs.list.offsetHeight;
      }, 1);
    },
    scrollToItem(){
      setTimeout(()=>{
        if ( !this.$refs.list ) return;
        const item = this.$refs.list.querySelector(`#compact-email-list-item-${this.firstSelectedEmail.id}`);
        if ( item ) item.scrollIntoView(true);
      }, 100);
    },
    handlePaginationChange(page){
      this.setPagination({page});
    },
    handleSelectItem( email ){
      const boxes = this.$refs.list.querySelectorAll('input[type=checkbox]');
      const selectedItems = []
      .filter
      .call( boxes, ( el ) => el.checked)
      .map(el => Number(el.value));
      
      // uses the selected email to determine the first selected, which will be shown
      const currentItemIndex = selectedItems.indexOf(email.id);
      const currentItem = selectedItems.splice(currentItemIndex, 1)[0];
      this.setSelectedEmails([currentItem, ...selectedItems]);
    },
    setControl(e){
      this.ctrlKey = e.ctrlKey;
    }
  },
  computed: {
    ...mapGetters("email", [
      "emails",
      "pagination",
      "firstSelectedEmail",
      "selectedEmails",
      "loading"
    ])
  },
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
.list-scroll{
  padding-right: $spacing-xxs;
}
.list-scroll::-webkit-scrollbar{
  width: $spacing-xxs;
}
.list-scroll::-webkit-scrollbar-track{
  background-color: #0000;
}
.list-scroll::-webkit-scrollbar-thumb{
  background-color: $color-grey-transparent;
  border-radius: $spacing-xxs;
}
</style>
